var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.98 15.1534C21.98 14.6748 21.937 14.2145 21.8573 13.7727H15.5V16.3837H19.1327C18.9763 17.2275 18.5007 17.9424 17.7858 18.421V20.1146H19.9673C21.2436 18.9395 21.98 17.2091 21.98 15.1534Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4998 21.75C17.3223 21.75 18.8503 21.1455 19.9671 20.1146L17.7856 18.421C17.1812 18.826 16.408 19.0653 15.4998 19.0653C13.7418 19.0653 12.2537 17.8779 11.7229 16.2825H9.46777V18.0313C10.5785 20.2374 12.8612 21.75 15.4998 21.75Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7231 16.2825C11.5881 15.8775 11.5114 15.4449 11.5114 15C11.5114 14.5551 11.5881 14.1225 11.7231 13.7175V11.9686H9.46795C9.0108 12.8799 8.75 13.9108 8.75 15C8.75 16.0892 9.0108 17.1201 9.46795 18.0314L11.7231 16.2825Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4998 10.9347C16.4908 10.9347 17.3806 11.2752 18.0802 11.9441L20.0162 10.0081C18.8472 8.91886 17.3193 8.25 15.4998 8.25C12.8612 8.25 10.5785 9.76261 9.46777 11.9686L11.7229 13.7175C12.2537 12.122 13.7418 10.9347 15.4998 10.9347Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.7d50c15df755f9d5918f3d3214e94184.svg";
export { ForwardRef as ReactComponent };